import { createStyles, makeStyles } from "@material-ui/core/styles";
import { DARK_GREY, WHITE, BACKGROUND_COLOR, BLACK } from "constants/colors";

export const useStyles = makeStyles(
createStyles({
    root: {
      "& .Mui-disabled":{
        color:"#757b86 !important"
      },
      "& .Mui-checked":{
        color: "#90caf9 !important"
      },
      "& #buscar":{
        height:"36px !important",
      },
      '& input[type="text"]::-ms-clear': {
        display: "none !important",
        height: "0 !important",
        width: "0 !important"
      },
    },
    item: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      marginTop: "24px",
    },
    itemLeft: {
      width: "40px",
      marginRight: 16,
      "& > img": {
        width: "80%",
      },
    },
    itemRight: {
      width: "100%",
      color: '#CFD9E6',
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 14,
    },
    hrTag: {
      background: "#625e5e",
      height: "2px",
      border: " 0",
      marginTop: "25px",
    },
    button: {
      padding: "8px 18px 10px 18px ",
      backgroundColor: "#363d47",
      border:"none",
      borderRadius: "20px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "auto",
      color: WHITE,
      "&:hover,&:focus": {
        color: BLACK,
        backgroundColor:"#90caf9",
        border:"none"
      },
      "& > span > span": {
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        marginLeft: 5,
        fontWeight: 600,
      },
    },
    textMessagegrid: {
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "16.41px",
      paddingLeft: "0px !important",
      letterSpacing: "normal",
      color: "#B8C1CC",
      margin: "0px",
      fontFamily: "Roboto",
      paddingBottom: "6px",
      width: "100%",
      display: "inline-block",
    },
    buttonExporter: {
      margin: "40px auto 16px",
      height: "auto",
      padding: "10px 16px",
      backgroundColor: "#363d47",
      border:"none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: WHITE,
      "&:hover,&:focus": {
        color: BLACK,
        backgroundColor: "#90caf9",
        border:"none"
      },
      "& > span > span": {
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        marginLeft: 5,
        fontWeight: 600,
      },
    },
    columnTitle: {
      backgroundColor: "#171a1f",
      color: "white",
    },

    columnDescName: {
      fontSize: "14px",
      overflow: "auto",
      height: "220px",
      gridGap: "10px",
      width: "100%",
    },
    SubcolumnDescName: {
      fontSize: "14px",
    },

    buttonDisabled: {
      opacity: 0.5,   
    },
    gridText: {
      marginBottom: "20px",
    },

    searchBox: {
      display: "flex",
      width: "100%",
      backgroundColor: "#363D47",
      padding: "7px 10px",
      color: "#FFFFFF",
      boxSizing: "border-box",
      borderRadius: "4px",
    },

    searchIcon: {
      margin:"5px",
      color: "rgb(118, 118, 118)",
    },

    search: {
      width: "100%",
      backgroundColor: "#363D47",
      outline: "0",
      border: "0px",
      boxSizing: "border-box",
      fontSize: "14px !important",
      color: "#FFFFFF",
      borderRadius: "4px",
      "& #buscar":{
        height:"36px !important",
      },
      "&::-ms-clear": {
        display: "none !important",
        width : 0,
        height: 0,
      },
 
      '& input[type="text"]::-ms-clear': {
        display: "none !important",
        height: "0 !important",
        width: "0 !important"
      },

    },
    highlightText: {
      color: "#90caf9",
    },
    checkBoxLabel: {
      color: WHITE,
      margin:"0px",
      "& .Mui-disabled":{
        color:"#757b86 !important"
      },
      "& .Mui-checked":{
        color: "#90caf9 !important"
      },
    },
    checkBoxLabelDisable:{
      color: WHITE,
      margin:"0px",
      "& .Mui-disabled":{
        color:"#757b86 !important"
      },
      "& .Mui-checked":{
        color: "#90caf9 "
      },
      marginRight:"0px !important"

    },
    checkBoxGridLabel:{
      color: WHITE,
      margin:"0px",
      "& .Mui-disabled":{
        color:"#757b86 !important"
      },
      "& .Mui-checked":{
        color: "#90caf9 !important"
      },
      marginRight:"0px !important"
    },
    checkbox: {
      color: "white",
        },
    ccssLabel: {
      color: '#CFD9E6',
    },
    cssFocused: {
      color: '#CFD9E6 !important'
    },
    cssOutlinedInput: {
      color: "white",
      outline: "0px",
      '&::after': {
        borderBottom: '2px solid #90caf9'
      },
      '&::before': {
        borderBottom: '2px solid #596c8d'
      },
      '&:hover:not($disabled):before': {
        borderBottom: '2px solid #90caf9 !important'

      },
    },
    forwardIcon:{
      fontSize:"1.0rem !important"
    }
  })
);
